export const filterNewsType = (news, type) => news.filter((item) => item.newType === type)

const isDmTalkDetailPage = (displayLocation) => /^\/talk_real\/detail\/\d+$/.test(displayLocation)

const isWithinOneHourBeforeStart = (startDisplayDate) => {
  const now = new Date()
  const start = new Date(startDisplayDate)
  const oneHourBefore = new Date(start.getTime() - 60 * 60 * 1000)
  return now >= oneHourBefore
}

export const filterDisplayTips = (news, type, displayLocation) => {
  const filterTips = filterNewsType(news, type)
  return filterTips.filter((item) => {
    if (item.displayLocation !== displayLocation) return false
    if (isDmTalkDetailPage(displayLocation)) return isWithinOneHourBeforeStart(item.startDisplayDate)
    return true
  })
}
